import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Layout } from 'antd';

import LandingHeader from './common/Header';
import LandingMain from './common/Main';
import LandingFooter from './common/Footer';
import { linesToParagraphs } from './common/Functions';
import Graph from './common/Graph';

import './css/landing.css';

const { Content } = Layout;

const graphicPoints = [
  { name: 'Point A', pv: 0 },
  { name: 'Point B', pv: 0 },
  { name: 'Point C', pv: 0 },
  { name: 'Point D', pv: 0 },
  { name: 'Point E', pv: 0 },
  { name: 'Point F', pv: 0 },
];
class LandingComponent extends React.Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
  };

  render() {
    const { isLoggedIn } = this.props;

    return (
      <Layout className="landing">
        <LandingHeader isLoggedIn={isLoggedIn} />
        {/*___________________________________________________*/}
        {/*_________________ C O N T E N T ___________________*/}
        {/*___________________________________________________*/}
        <Content className="landing__content">
          <LandingMain headerId="landing.contentHeader.line" subtitleId="landing.contentSubtitle.line">
            <Col className="landing__content--benefit" xs={24} sm={7} lg={7}>
              <FormattedMessage
                id="landing.contentBenefit.item1"
                defaultMessage="Defeat fraud and cheating"
                description="text for benefit item #1"
              />
            </Col>
            <Col className="landing__content--benefit" xs={24} sm={8} lg={8}>
              <FormattedMessage
                id="landing.contentBenefit.item2"
                defaultMessage="Increase ROI, significantly reducing advertising costs"
                description="text for benefit item #2"
              />
            </Col>
            <Col className="landing__content--benefit" xs={24} sm={9} lg={9}>
              <FormattedMessage
                id="landing.contentBenefit.item3"
                defaultMessage="Manage all your affiliate programs on their own"
                description="text for benefit item #3"
              />
            </Col>
          </LandingMain>
          <div className="bg-white">
            <div className="container">
              {/*___________________________________________________*/}
              {/*_________________ S E R V I C E S _________________*/}
              {/*___________________________________________________*/}
              <Row className="landing__content--services" justify="space-between" type="flex">
                <Col className="landing__content--service" xs={24} sm={24} md={12}>
                  <h2>
                    <FormattedMessage
                      id="landing.service.title1"
                      defaultMessage="Lead verification"
                      description="Header for service #1"
                    />
                  </h2>
                  <p className="landing__content--service-desc">
                    <FormattedMessage
                      id="landing.service.description1"
                      defaultMessage="Buy only genuine leads"
                      description="Description for service #1"
                    >
                      {linesToParagraphs}
                    </FormattedMessage>
                  </p>
                  <Graph data={graphicPoints} />
                </Col>
                <Col className="landing__content--service" xs={24} sm={24} md={11}>
                  <h2>
                    <FormattedMessage
                      id="landing.service.title2"
                      defaultMessage="Anti-fraud"
                      description="Header for service #2"
                    />
                  </h2>
                  <p className="landing__content--service-desc">
                    <FormattedMessage
                      id="landing.service.description2"
                      defaultMessage="Filter out fraudulent traffic before you pay for it"
                      description="Description for service #2"
                    >
                      {linesToParagraphs}
                    </FormattedMessage>
                  </p>
                  <Graph data={graphicPoints} />
                </Col>
                <Col className="landing__content--service" xs={24} sm={24} md={12}>
                  <h2>
                    <FormattedMessage
                      id="landing.service.title3"
                      defaultMessage="Client path"
                      description="Header for service #3"
                    />
                  </h2>
                  <p className="landing__content--service-desc">
                    <FormattedMessage
                      id="landing.service.description3"
                      defaultMessage="What do your customers want? Compare the behavior of your customers on all sites, from any device"
                      description="Description for service #3"
                    >
                      {linesToParagraphs}
                    </FormattedMessage>
                  </p>
                  <Graph data={graphicPoints} />
                </Col>
                <Col className="landing__content--service" xs={24} sm={24} md={11}>
                  <h2>
                    <FormattedMessage
                      id="landing.service.title4"
                      defaultMessage="Predictive analytics"
                      description="Header for service #4"
                    />
                  </h2>
                  <p className="landing__content--service-desc">
                    <FormattedMessage
                      id="landing.service.description4"
                      defaultMessage="Evaluate the role of each traffic channel in the context of the partner program, webmaster, creative, device type, any other channel"
                      description="Description for service #4"
                    >
                      {linesToParagraphs}
                    </FormattedMessage>
                  </p>
                  <Graph data={graphicPoints} />
                </Col>
                <Col className="landing__content--service" xs={24} sm={24} md={11}>
                  <h2>
                    <FormattedMessage
                      id="landing.service.title5"
                      defaultMessage="Affiliate and client control"
                      description="Header for service #5"
                    />
                  </h2>
                  <p className="landing__content--service-desc">
                    <FormattedMessage
                      id="landing.service.description5"
                      defaultMessage="Predict and manage the performance and behavior of your clients and affiliates"
                      description="Description for service #5"
                    >
                      {linesToParagraphs}
                    </FormattedMessage>
                  </p>
                  <Graph data={graphicPoints} />
                </Col>
                <Col className="landing__content--service" xs={24} sm={24} md={11}>
                  <h2>
                    <FormattedMessage
                      id="landing.service.title6"
                      defaultMessage="Dedicated approach"
                      description="Header for service #6"
                    />
                  </h2>
                  <p className="landing__content--service-desc">
                    <FormattedMessage
                      id="landing.service.description6"
                      defaultMessage="Individual self-learning data model for every client"
                      description="Description for service #6"
                    >
                      {linesToParagraphs}
                    </FormattedMessage>
                  </p>
                  <Graph data={graphicPoints} />
                </Col>
                <Col className="landing__content--service" xs={24} sm={24} md={24}>
                  <FormattedMessage
                    id="landing.service.description7"
                    defaultMessage="Conduster’s machine learning solution analyzes clicks, leads, installs, payments and all-known other types of users and affiliates activities to find the abnormalities, reducing the number of false-positive and false-negative errors. This allows Conduster to spot scammers even when they change their technology, masking fake conversions under that looking authentically, and control users and affiliates behavior in terms of attraction, retention and return."
                    description="Description for service #7"
                  >
                    {linesToParagraphs}
                  </FormattedMessage>
                </Col>
              </Row>
            </div>
          </div>
        </Content>
        {/*___________________________________________________*/}
        {/*_________________ F O O T E R  ____________________*/}
        {/*___________________________________________________*/}
        <LandingFooter />
      </Layout>
    );
  }
}

export default LandingComponent;



// WEBPACK FOOTER //
// ./src/components/landing/index.js